<template>
  <div class="ex_help">
    <div class="ex_help_top" @click="topRankClick">
      <p>活动排行 {{top>10?'No.':'TOP'}}{{top}}</p>
        <span class="line" v-if="false"></span>
        <p class="help" v-if="false">助力</p>
        <i class="iconfont icon-xiangyou-copy " v-if="false"></i>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import gql from 'graphql-tag';
// import liveDzCount from "@/components/live-dz-count/index";
export default {
  name: "ex-help-rank",
  components: {
  },
  data() {
    return {
      rankList: [],
      hotVal: 0,
      top: "",
      orderType: "",
      rankMsg:null,
    };
  },
  computed: {
    ...mapGetters({
      exhibitionId:"getExhibitionId"
    }),
    query() {
      return this.$router.history.current.query;
    },
  },
  created(){
    this.liveInit();
  },
  mounted(){
    this.$Bus.$on('moneyOk',()=>{
      // 重新查询top值
      this.$apollo.queries.getActivityRanking.refetch()
    });
  },
  methods: {
    ...mapActions({
      LinkRegistry: "linkTo/LinkRegistry", //注册
    }),
    // 人数超过w换算
    getCount(param) {
      let count = 0;
      if (param > 10000) {
        count = (param / 10000).toFixed(1);
        if (String(count)[count.length - 1] == 0) {
          count = (count / 1).toFixed(0);
        }
        return count + "w";
      }
      return param;
    },
    liveInit() {
      const query = gql`
        query getActivityRanking($exhibitionId:Guid!,$activityId:Guid!){
          getActivityRanking(exhibitionId:$exhibitionId,activityId:$activityId){
            id
            no
            power
          }
        }
      `;
      this.$apollo.addSmartQuery("getActivityRanking", {
        query: query,
        variables: {
          exhibitionId:this.exhibitionId,
          activityId:this.query.actId
        },
        fetchPolicy: "network-only", //清理缓存
        result(res) {
          console.log('热榜排名',res)
          let data = JSON.parse(JSON.stringify(res.data.getActivityRanking));
          if (data) {
            this.top = data.no || "";
            this.hotVal=data.power
          }
        },
        error(err) {},
      });
    },
    //助力上榜
    topRankClick() {
      // console.log('asdsad')
      this.$Bus.$emit("helpClick");
    },
    //去注册
    goToregistry() {
      this.LinkRegistry(0);
    }
  },
  beforeDestroy(){
    this.$Bus.$off('moneyOk')
  }
};
</script>

<style scoped lang="scss">
.ex_help {
  display: flex;
  height: .64rem;
  justify-content: space-between;
  align-items: center;
//   margin-top: 16px;
//   padding: 0 30px;
  position: absolute;
  right: .3rem;
  top: .2rem;
  z-index: 300;
  .ex_help_top {
    height: 100%;
    border-radius: .32rem;
    background-color: rgba(0, 0, 0, 0.4);
    box-sizing: border-box;
    padding: 0 .24rem;
    display: flex;
    align-items: center;
    color: #fff;
    font-size: .2rem;
    p{
      white-space: nowrap;
      font-size: .2rem;
    }
    p.help{
        font-size: .24rem;
        line-height: 0.64rem;
        // transform: translateY(0.01rem);
    }
    
    .line {
        height: .28rem;
        width: 1px;
        background: #fff;
        display: block;
        margin: 0 .1rem;
    }
    .iconfont {
      font-size: .36rem;
      &.y_bias{
       transform:translateY(2px); 
      }
      // margin-left: 7px;
    } 
  }
  .count_wrap{
    display: flex;
    .help_count {
      height: 46px;
      padding: 0 20px;
      box-sizing: border-box;
      border-radius: 23px;
      display: flex;
      align-items: center;
      font-size: 20px;
      color: #f85b0f;
      background: #fff;
    }
  }
}
</style>
